module.exports = __webpack_public_path__ + "img/palm2_7.2d5cfff3.png";